// biome-ignore lint/suspicious/noExplicitAny: Init Biome
export const isset = (value: any) => !['', null, undefined].includes(value);

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
export const not = (value: any) => [null, undefined, '', NaN].includes(value);

export const omit = <Data extends object, Keys extends keyof Data>(
	data: Data,
	keys: Keys[]
): Omit<Data, Keys> => {
	const entries = Object.entries(data).filter(
		([key]) => !keys.includes(key as Keys)
	);
	return Object.fromEntries(entries) as Omit<Data, Keys>;
};

export const pick = <Data extends object, Keys extends keyof Data>(
	data: Data,
	keys: Keys[]
): Pick<Data, Keys> => {
	const entries = Object.entries(data).filter(([key]) =>
		keys.includes(key as Keys)
	);
	return Object.fromEntries(entries) as Pick<Data, Keys>;
};

export const sanitizeObject = <T extends object>(
	obj: T,
	options?: { clearEmptyArray: boolean; keepEmptyString?: boolean }
): T => {
	if (typeof obj !== 'object') return {} as T;

	const { clearEmptyArray = false, keepEmptyString = false } = options ?? {};

	const entries = Object.entries(obj).filter(([, value]) => {
		if (Array.isArray(value)) return !clearEmptyArray || value.length > 0;
		if (typeof value === 'string' && value === '') return keepEmptyString;
		return !not(value);
	});
	return Object.fromEntries(entries) as T;
};

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
export const makeArray = (data: any): any[] =>
	Array.isArray(data) ? data : [data];

export const sleep = (ms: number) =>
	new Promise((resolve) => setTimeout(resolve, ms));
